import { drypApi } from "@/services/drypApi";

interface AddUserGroupRequest {
	name: string;
	description: string;
}

interface EditUserGroupRequest {
	name: string;
	description: string;
	idUserGroup: Dryp.UserGroupId;
}

interface deleteUserGroupRequest {
	idUserGroup: Dryp.UserGroupId;
}

export const userGroups = {
	getUserGroups: async (): Promise<Dryp.UserGroup[]> => {
		return drypApi.get<Dryp.UserGroup[]>(`/api/UserGroups/GetAllGroups`);
	},
	addUserGroup: async (payload: AddUserGroupRequest): Promise<Dryp.UserGroup | null> => {
		return drypApi.put<Dryp.UserGroup | null>(`/api/UserGroups/CreateGroup`, payload);
	},
	editUserGroup: async (payload: EditUserGroupRequest): Promise<Dryp.UserGroup | null> => {
		return drypApi.post<Dryp.UserGroup | null>(`/api/UserGroups/UpdateGroup`, payload);
	},
	deleteUserGroup: async ({ idUserGroup }: deleteUserGroupRequest): Promise<boolean | null> => {
		return drypApi.delete<boolean | null>(`/api/UserGroups/DeleteGroup/${idUserGroup}`);
	},
};
